import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import {
  Box,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { UserContext } from "../../context/UserContext";
import PageContainer from "../../components/page-container/PageContainer";

const SignOutPage = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "error" });

  useEffect(() => {
    const auth = getAuth();
    (async () => {
      try {
        await signOut(auth);
        setUser(null);
        navigate("/", { replace: true });
      } catch (err) {
        setSnackbar({ open: true, message: err.message, severity: "error" });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  return (
    <PageContainer>
      <Box>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Signing you out…
        </Typography>
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert severity={snackbar.severity} onClose={handleCloseSnackbar} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </PageContainer>
  );
}

export default SignOutPage;
